import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Alert,
  Divider,
} from "@mui/material";
import {
  useFetchSettingsQuery,
  useUpdateSettingsMutation,
} from "../../store/services/settingsService";
import colors from "../../styles/colors";
import Loader from "../../components/Loader";
import Editor from "../../components/TextEditor";
import { useSelector } from "react-redux";



const labelStyle = {
  fontFamily: "PMe",
  fontSize: 14,
  color: colors.textBlack,
  mb: 0.5,
};



const tabs = [
  { label: "Settings", value: "settings" },
  { label: "Terms & Privacy settings", value: "terms" },
]


const SettingsPage = () => {

  const words = useSelector((state)=> state.authReducer.words);
  const { data: settingsData, isLoading, error } = useFetchSettingsQuery();
  const [focusedTab, setFocusedTab] = useState('settings');
  const [updateSettings, { isLoading: isUpdating, isSuccess, isError }] =
    useUpdateSettingsMutation();

  const [settings, setSettings] = useState({
    company_name: "",
    support_email: "",
    support_phone: "",
    company_instagram: "",
    company_facebook: "",
    company_x: "",
    terms: "",
    privacy_policy: "",
  });

  useEffect(() => {
    if (settingsData) {
      setSettings(settingsData.data || {});
    }
  }, [settingsData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await updateSettings(settings).unwrap();
    } catch (err) {
      console.error("Error updating settings:", err);
    }
  };



  return (
    <Box sx={{padding: 4,}} >
    <Box sx={{  maxWidth: 800, }}>

      <Box sx={{ backgroundColor: colors.white, pr: 5, pt: 1, borderRadius: '10px', display: 'flex', flexDirection: 'row', mb: 5 }}>
        {
          tabs.map((v, i) => {
            return (
              <Box
                onClick={() => setFocusedTab(v.value)}
                sx={{ cursor: 'pointer', ml: 5 }}
              >
                <Typography sx={{ fontFamily: 'PMe', fontSize: 15, color: focusedTab === v.value ? colors.textPrimary : colors.dimText }}>
                  {v.label}
                </Typography>
                {focusedTab === v.value && <Box sx={{ width: '100%', height: 3, backgroundColor: colors.primary, mt: 1, borderRadius: 5 }} />}
              </Box>
            )
          })
        }
      </Box>


      {/* <Typography variant="h4" sx={{ fontFamily: "PBo", mb: 3 }}>
        Settings
      </Typography> */}
      {error && <Alert severity="error" sx={{ mb: 2 }}>Failed to load settings.</Alert>}
      {isError && <Alert severity="error" sx={{ mb: 2 }}>Failed to save settings.</Alert>}
      {isSuccess && <Alert severity="success" sx={{ mb: 2 }}>Settings updated successfully!</Alert>}

      {
        focusedTab == 'settings' &&
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Company Name</Typography>
              <TextField

                name="company_name"
                fullWidth
                value={settings.company_name || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Support Email</Typography>
              <TextField
                name="support_email"
                fullWidth
                value={settings.support_email || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Support Phone</Typography>
              <TextField

                name="support_phone"
                fullWidth
                value={settings.support_phone || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Company Instagram</Typography>
              <TextField

                name="company_instagram"
                fullWidth
                value={settings.company_instagram || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Company Facebook</Typography>
              <TextField

                name="company_facebook"
                fullWidth
                value={settings.company_facebook || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelStyle} >Company X (Twitter)</Typography>
              <TextField

                name="company_x"
                fullWidth
                value={settings.company_x || ""}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </>
      }
</Box>
      {
        focusedTab == 'terms' &&
        <Box sx={{ display: 'flex',  gap: 4, width: '100%',backgroundColor:colors.white, }}>
        <Box sx={{ boxShadow: 3, display: 'flex', flexDirection: 'column', borderRadius: 2, p: 3, overflow: 'hidden' }}>
          <Typography sx={labelStyle} >
            {words["Terms and Conditions"]}
          </Typography>
          <Divider sx={{ mt: 2, mb: 2, borderColor: '#D9D9D9' }} />
          <Editor
            initialContent={settings.terms}
            onChange={(text) => {
              setSettings({
                ...settings,
                terms: text
              })
            }}
            height="200px" // Or use a similar prop for your text editor to control the height
          />
        </Box>
  
        <Box sx={{ boxShadow: 3, display: 'flex', flexDirection: 'column', borderRadius: 2, p: 3, height: 320, overflow: 'hidden' }}>
          <Typography sx={labelStyle}>
            {words["Privacy policy"]}
          </Typography>
          <Divider sx={{ mt: 2, mb: 2, borderColor: '#D9D9D9' }} />
          <Editor
            initialContent={settings.privacy_policy}
            onChange={(text) => {
              setSettings({
                ...settings,
                privacy_policy: text
              })
            }}
            height="200px" // Or use a similar prop for your text editor to control the height
          />
        </Box>
  
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="contained" color="primary" >
            {words["Save"]}
          </Button>
        </Box> */}
      </Box>
      }

      <Loader open={isLoading} />
      <Button
            variant="contained"
            sx={{ mt: 3, backgroundColor: "rgba(247, 181, 0)",textTransform:'capitalize',fontFamily:'PMe' }}
            onClick={handleSave}
            disabled={isUpdating}
          >
            {isUpdating ? "Saving..." : "Save Settings"}
          </Button>
    </Box>
  );
};

export default SettingsPage;




// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   IconButton,
//   Button,
//   Pagination,
//   Dialog,
//   DialogTitle,
//   TextField,
//   DialogActions,
//   DialogContent,
//   Box,
// } from "@mui/material";
// import { EditNote, DeleteOutline, Close } from "@mui/icons-material";
// import colors from "../../styles/colors";
// import { useSelector } from "react-redux";
// import Loader from "../../components/Loader";
// import { toast } from "react-toastify";
// import RentContractSettings from "./RentContractSettings";



// const tabs = [
//   { label: "Settings", value: "vehicleData" },
//   { label: "Terms & Privacy settings", value: "appSettings" },
// ]








// const Settings = () => {


//   const words = useSelector((state) => state.authReducer.words);
//   const [focusedTab, setFocusedTab] = useState('vehicleData');
//   const [appColor, setAppColor] = useState('');
//   const [tempAppColor, setTempAppColor] = useState(''); // Temporary state for unsaved changes


//   const labelStyle = {
//     fontFamily: 'PSBo',
//     fontSize: 13,
//     color: colors.text,
//     mb: 0.5
//   }

  



//   return (
//     <Box sx={{ p: 3, backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
//       <Box sx={{ backgroundColor: colors.white, pr: 5, pt: 1, borderRadius: '10px', display: 'flex', flexDirection: 'row' }}>
//         {
//           tabs.map((v, i) => {
//             return (

//               <Box
//                 onClick={() => setFocusedTab(v.value)}
//                 sx={{ cursor: 'pointer', ml: 5 }}
//               >
//                 <Typography sx={{ fontFamily: 'PMe', fontSize: 15, color: focusedTab === v.value ? colors.textPrimary : colors.dimText }}>
//                   {v.label}
//                 </Typography>
//                 {focusedTab === v.value && <Box sx={{ width: '100%', height: 3, backgroundColor: colors.primary, mt: 1, borderRadius: 5 }} />}
//               </Box>
//             )
//           })
//         }
//       </Box>
//       {focusedTab == 'rentContractSettings' && <RentContractSettings />}
      

//     </Box>
//   );
// };

// export default Settings;
